<template>
  <v-navigation-drawer
    app
    :mini-variant="isMinimal && !$vuetify.breakpoint.lgAndUp"
    :width="navbarWidth"
    :mini-variant-width="navbarMinWidth"
    v-model="$store.state.showDrawer"
    enable-resize-watcher
    :right="$store.state.rtl"
    :permanent="$vuetify.breakpoint.lgAndUp"
    class="modern-sidebar"
  >
    <div class="d-flex flex-column fill-height">
      <!-- Brand Logo Header -->
      <div class="sidebar-header d-flex align-center justify-space-between px-5 py-4">
        <img
          :src="
            $vuetify.theme.dark
              ? require('@/app/core-module/assets/images/LOGO_DARK_MODE.png')
              : require('@/app/core-module/assets/images/LOGO.png')
          "
          alt="ZeroSuite Logo"
          class="hand-cursor"
          style="max-width: 145px; height: auto; object-fit: contain;"
          @click="redirect({ routeName: 'Home' })"
        />

        <!-- minimise button on tablet/mobile -->
        <v-btn
          v-if="!$vuetify.breakpoint.lgAndUp"
          icon
          small
          @click="isMinimal = !isMinimal"
        >
          <v-icon color="textLight" small>
            {{
              !$store.state.rtl
                ? isMinimal
                  ? "mdi-chevron-double-right"
                  : "mdi-chevron-double-left"
                : !isMinimal
                ? "mdi-chevron-double-right"
                : "mdi-chevron-double-left"
            }}
          </v-icon>
        </v-btn>
      </div>

      <v-divider class="mx-4 mb-2" style="border-color: rgba(15, 23, 42, 0.06);" />

      <!-- Navigation Items -->
      <div class="sidebar-nav-list flex-grow-1 px-3 py-1">
        <div
          v-for="(item, index) in items"
          :key="`navbar_${item.routeName}_${index}`"
          class="nav-pill d-flex align-center px-3 my-1 hand-cursor"
          :class="
            item.routeName === $route.name ||
            item.relatedRouteNames.includes($route.name)
              ? 'nav-pill--active'
              : 'nav-pill--inactive'
          "
          @click="redirect(item)"
        >
          <v-icon
            size="20"
            class="nav-pill__icon me-3"
            v-text="item.icon ? item.icon.trim() : ''"
          />
          <span
            v-if="$vuetify.breakpoint.lgAndUp || !isMinimal"
            class="nav-pill__label text-truncate"
          >
            {{ item.name }}
          </span>
        </div>
      </div>

      <!-- Footer -->
      <div class="px-5 py-3 mt-auto">
        <v-divider class="mb-3" style="border-color: rgba(15, 23, 42, 0.06);" />
        <div class="d-flex align-center justify-space-between caption sidebar-footer-text">
          <span>{{ $t("poweredBy") }}</span>
          <strong class="primary--text">ZeroSuite</strong>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      isMinimal: false,
      version: "1.0",
      selectedTabIndex: 0,
      right: null,
      subscriberInfo: null,
    };
  },
  created() {
    //update languange
    if (this.$route.params.lang === "ar") {
      // i18n.locale = "ar";
      this.$vuetify.rtl = true;
      this.$store.commit("UPDATE_RTL", true);
    } else {
      // i18n.locale = "en";
      this.$vuetify.rtl = false;
      this.$store.commit("UPDATE_RTL", false);
    }
  },

  apollo: {
    getSubscriberProfile() {
      return {
        query: require("../../user-module/api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.subscriberInfo = data.getSubscriberProfile;
          }
        },
      };
    },
  },

  computed: {
    navbarWidth() {
      return !this.$vuetify.breakpoint.lgAndUp ? "230px" : "230px";
    },
    navbarMinWidth() {
      return "72px";
    },
    items() {
      return [
        {
          name: this.$t("navBarItems.home"),
          icon: " mdi-home-outline",
          routeName: "Home",
          relatedRouteNames: [],
        },
        {
          name: this.$t("navBarItems.courses"),
          icon: "mdi-book-open-page-variant-outline",
          routeName: "Courses",
          relatedRouteNames: [
            "CourseDetails",
            "CourseCertificate",
            "CourseCertificateDownload",
          ],
        },
        {
          name: this.$t("quiz.assessments"),
          icon: "mdi-comment-question-outline",
          routeName: "Assessments",
          relatedRouteNames: ["AssessmentDetails"],
        },
        {
          name: this.$t("navBarItems.profile"),
          icon: "mdi-account-circle-outline",
          routeName: "Profile",
          relatedRouteNames: [],
        },
      ];
    },
  },
  watch: {
    $route: {
      handler: function (newValue) {
        this.updateTabIndex(newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    redirect(item) {
      if (item.routeName !== this.$route.name)
        this.$router.push({ name: item.routeName });
    },
    updateTabIndex(route) {
      this.selectedTabIndex = this.items.findIndex(
        item =>
          item.routeName === route.name ||
          item.relatedRouteNames.includes(route.name)
      );
    },
  },
};
</script>

<style scoped>
>>> .v-navigation-drawer__border {
  background-color: rgba(15, 23, 42, 0.06) !important;
}

>>> .v-navigation-drawer__content {
  overflow-y: auto;
  scrollbar-width: none;
}
>>> .v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}

.sidebar-nav-list {
  overflow-y: auto;
  scrollbar-width: none;
}
.sidebar-nav-list::-webkit-scrollbar {
  display: none;
}

.nav-pill {
  height: 42px;
  border-radius: 10px;
  transition: all 0.18s ease;
  position: relative;
  user-select: none;
}

.nav-pill__label {
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.nav-pill--inactive {
  color: #475569;
}
.nav-pill--inactive >>> .nav-pill__icon {
  color: #64748b !important;
}
.nav-pill--inactive:hover {
  background-color: #f8fafc;
  color: #0f172a;
}
.nav-pill--inactive:hover >>> .nav-pill__icon {
  color: #2563eb !important;
}

.nav-pill--active {
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}
.nav-pill--active .nav-pill__label {
  font-weight: 600;
}
.nav-pill--active >>> .nav-pill__icon {
  color: #2563eb !important;
}
.nav-pill--active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3.5px;
  border-radius: 0 4px 4px 0;
  background-color: #2563eb;
}

.sidebar-footer-text {
  color: #64748b;
}
</style>
